import Vue from 'vue';

const qrQueue = new Vue({
  data() {
    return {
      tasks: {}
    };
  },
  methods: {
    startTask(id, total, title = '') {
      this.$set(this.tasks, id, {
        id,
        title,
        current: 0,
        total,
        status: 'running',
        currentTitle: title,
        percent: 0
      });
      this.$emit('task-updated');
    },

    updateProgress(id, current, total, currentTitle = '') {
      if (!this.tasks[id]) return;
      const percent = total > 0 ? Math.round((current / total) * 100) : 0;
      this.$set(this.tasks, id, {
        ...this.tasks[id],
        current,
        total,
        currentTitle,
        percent,
        status: 'running'
      });
      this.$emit('task-updated');
    },

    finishTask(id) {
      if (!this.tasks[id]) return;
      this.$set(this.tasks, id, {
        ...this.tasks[id],
        current: this.tasks[id].total,
        percent: 100,
        status: 'finished'
      });
      this.$emit('task-updated');
      setTimeout(() => {
        this.removeTask(id);
      }, 4000);
    },

    failTask(id, error) {
      if (!this.tasks[id]) return;
      this.$set(this.tasks, id, {
        ...this.tasks[id],
        status: 'failed',
        error
      });
      this.$emit('task-updated');
    },

    removeTask(id) {
      this.$delete(this.tasks, id);
      this.$emit('task-updated');
    }
  }
});

if (typeof window !== 'undefined') {
  window.__QR_QUEUE_INSTANCE__ = qrQueue;
}

export { qrQueue };
export default qrQueue;
